import { List } from "@mantine/core";
import type { FC } from "react";
import { useIntl } from "react-intl";

const DefaultMarketingFeatures: FC<{ features: { name?: string }[] }> = ({ features }) => {
  return features.map(({ name }) => (
    <List.Item key={name}>{name}</List.Item>
  ));
};

const MarketingFeaturesProPlan = () => {
  const intl = useIntl();
  return [
    <List.Item key="unlimited-projects">
      {intl.formatMessage({
        id: "listItem.unlimitedProjects",
        defaultMessage: "Unlimited projects",
      })}
    </List.Item>,
    <List.Item key="unlimited-users">
      {intl.formatMessage({
        id: "listItem.unlimitedUsers",
        defaultMessage: "Unlimited users",
      })}
    </List.Item>,
    <List.Item key="priority-support">
      {intl.formatMessage({
        id: "listItem.prioritySupport",
        defaultMessage: "Priority support",
      })}
    </List.Item>,
  ];
};

const MarketingFeaturesStarterPlan = () => {
  const intl = useIntl();
  return [
    <List.Item key="3-users">
      {intl.formatMessage({
        id: "listItem.threeUsers",
        defaultMessage: "3 users",
      })}
    </List.Item>,
    <List.Item key="3-projects">
      {intl.formatMessage({
        id: "listItem.threeProjects",
        defaultMessage: "3 projects",
      })}
    </List.Item>,
  ];
};

const MarketingFeaturesFreePlan = () => {
  const intl = useIntl();
  return [
    <List.Item key="one-user">
      {intl.formatMessage({
        id: "listItem.oneUser",
        defaultMessage: "1 user",
      })}
    </List.Item>,
    <List.Item key="one-project">
      {intl.formatMessage({
        id: "listItem.oneProject",
        defaultMessage: "1 project",
      })}
    </List.Item>,
  ];
};

const ProductToFeatures: Record<string, FC> = {
  tenacify_pro: MarketingFeaturesProPlan,
  tenacify_starter: MarketingFeaturesStarterPlan,
  tenacify_free: MarketingFeaturesFreePlan,
};

interface ProductFeaturesProps {
  productId: string;
  features: { name?: string }[];
};

export const ProductFeatures: FC<ProductFeaturesProps> = ({ productId, features }) => {
  const ProductFeaturesForProduct = ProductToFeatures[productId];
  if (ProductFeaturesForProduct) {
    return <ProductFeaturesForProduct />;
  };
  return <DefaultMarketingFeatures features={features} />;
};
